module.exports = __webpack_public_path__ + "static/media/walking60.46355ca7.mp3";